import { useEffect, useState } from "react";
import axios from "axios";
const useVeggieItems = () => {
  const [veggieItem, setVeggieItem] = useState("野菜");
  const [veggieData, setVeggieData] = useState("");
  const [title, setTitle] = useState("野菜");
  useEffect(() => {
    // setVeggieData(itemsFullData.filter((x) => x._id === veggieItem));
    const item = veggieItem ? veggieItem : "野菜";
    // setVeggieData(itemsFullData.filter((x) => x._id === item)[0]);
    axios
      .get(`${process.env.REACT_APP_KOKU}/koku/${item}`)
      .then((response) => {
        setVeggieData(response.data);

        //
      })
      .catch((error) => {
        console.log(error);
      });
  }, [veggieItem]);
  const onClickChangeVeggieData = (id, titleType) => {
    setVeggieItem(id);
    setTitle(titleType);
  };
  const onClickMobile = (id) => {
    if (veggieItem === id) {
      setVeggieItem("");
    } else {
      setVeggieItem(id);
    }
  };
  return {
    veggieData,
    title,
    onClickChangeVeggieData,
    onClickMobile,
    veggieItem,
  };
};

export default useVeggieItems;
